import { isRetina } from '@browsing/utils';

import { GridBlockDimensions } from '@client/components/mylounge/campaigns/grid/constants';
import { Campaign, CategoryTab } from '@shared/types/mylounge';
import { IMAGES_WIDTH, GridBlockDimensionsToWidth } from './constants';

export const getUrlWithWidth = (url: string, width: number): string => {
    if (!url) {
        return '';
    }

    const density = isRetina() ? 2 : 1;

    return width > 0 ? `${url}?imwidth=${width}&imdensity=${density}` : url;
};

export const getBannerDesktopImage = (tab: CategoryTab) => {
    return getUrlWithWidth(tab?.thb?.horizontalImage, IMAGES_WIDTH.DESKTOP_BANNER);
};

export const getBannerMobileImage = (tab: CategoryTab) => {
    return getUrlWithWidth(tab?.thb?.verticalImage, IMAGES_WIDTH.MOBILE);
};

export const getCampaignGridImage = (
    campaign: Campaign,
    aspectRatio: GridBlockDimensions = GridBlockDimensions.SQUARE_SMALL,
) => {
    const imageUrl = campaign?.images?.campaigns?.find(
        campaignImage => campaignImage?.aspectRatio === aspectRatio,
    )?.url;

    return getUrlWithWidth(imageUrl, GridBlockDimensionsToWidth[aspectRatio]);
};

export const roundImageWidth = (width: number): number => {
    if (!width || width < 0) {
        return 0;
    }

    if (width > 4000) {
        return 5000;
    }

    let multiplier = 50;

    if (width <= 500) {
        multiplier = 50;
    } else if (width <= 1000) {
        multiplier = 100;
    } else if (width <= 2000) {
        multiplier = 250;
    } else if (width <= 4000) {
        multiplier = 500;
    }

    return Math.ceil(width / multiplier) * multiplier;
};

export const getCampaignMobileImage = (campaign: Campaign) => {
    return getUrlWithWidth(campaign?.images?.mobile, IMAGES_WIDTH.MOBILE);
};
